'use strict';

const Constants = require('./NavConstants');

const NavActions = function (Flux, APP_DISPATCHER_ID) {

  const Actions = Flux.Actions.create(Constants.ACTIONS_ID, APP_DISPATCHER_ID);

  Actions.add({
    name: 'CloseDrawer',
    purpose: 'Close the nav drawer, and optionally restore page and view to a default state',
    payload: ['page', 'view']
  });

  Actions.add({
    name: 'OpenDrawer',
    purpose: 'Open the nav drawer to the specified page and optionally set the view',
    payload: ['page', 'view']
  });

  Actions.add({
    name: 'ChangeDrawerPage',
    purpose: 'Change to a specific nav drawer page and optionally set the view',
    payload: ['page', 'view']
  });

  Actions.add({
    name: 'ChangeDrawerPageView',
    purpose: 'Change to a specific nav drawer page view',
    payload: ['view']
  });

  Actions.add({
    name: 'ChangeDrawerWhileDisabled',
    purpose: 'Show confirmation popup when user tries to leave edit page via left navigation',
    payload: ['to']
  });

  Actions.add({
    name: 'ContinueWithNavigation',
    purpose: 'Allow user to switch from edit mode to another view while cleaning up edit view',
    payload: []
  });

  return Actions;
};

NavActions.$inject = ['sbFlux', 'APP_DISPATCHER_ID'];
module.exports = NavActions;


// WEBPACK FOOTER //
// ./src/app/dash/nav/NavActions.js